import { render, staticRenderFns } from "./WaitlistComp.vue?vue&type=template&id=786205e3"
import script from "./WaitlistComp.vue?vue&type=script&lang=ts"
export * from "./WaitlistComp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports